<template>
	<footer class="footer-container">
		<span v-html="footerText" />
	</footer>
</template>

<script>
export default {
	name: 'Footer',
	data() {
		return {
			footerText: document.getElementById('footer-text').value
		};
	}
};
</script>
